// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectOfficeLayoutQueryResult, selectOfficeLayoutsPageLoading, selectOfficeLayoutsShowInitWaitingMessage} from '../_selectors/office-layout.selectors';

export class OfficeLayoutsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectOfficeLayoutsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectOfficeLayoutsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectOfficeLayoutQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
